<template>
  <div class="container" v-if="!store.loggedIn">
    <!-- Theme Switch -->
    <div class="theme-switch-container">
      <button class="theme-switch" @click="toggleTheme">
        <font-awesome-icon :icon="['fas', currentTheme === 'dark' ? 'sun' : 'moon']" />
      </button>
    </div>
    
    <img class="logo" :class="{ 'inverted': currentTheme === 'light' }" src="/static/img/KovoLogoPadding.svg" alt="">
    <div>
      <div class="loginContainer cardBackground">
        <h1>Login</h1>
        <div class="emailContainer">
          <input class="loginInput" type="text" v-model="email" @keyup.enter="handleEmailEnter" placeholder="User Name" style="border-color: #45403C;">
        </div>
        <div class="passwordContainer">
          <input class="loginInput" ref="password" :type="viewPassword ? 'text' : 'password'" v-model="password" @keyup.enter="login" placeholder="Password" style="border-color: #45403C;">
          <svg @click="togglePasswordVisibility" class="viewPasswordIcon" :class="viewPassword ? 'colorSwap' : ''"><use href="/static/icons/Eye.svg#Eye"/></svg>
        </div>
        <div class="dropdownWrapper">
          <div class="dropdownToggle" @click="toggleDropdown">
            <svg class="dropdownCaret" :class="{ 'rotated': showDropdown }">
              <use href="/static/icons/RightCaret.svg#RightCaret"/>
            </svg>
            <span>Other Options</span>
          </div>
          <div class="dropdownContent" :class="{ 'show': showDropdown }">
            <div class="dropdownItem">
              <router-link to="/user-registration" class="dropdownButton">
                Register
              </router-link>
            </div>
            <div class="dropdownItem">
              <router-link to="/forgot-password" class="forgotPasswordLink">
                Forgot Password?
              </router-link>
            </div>
          </div>
        </div>
        <div>
          <button class="specialButton" @click="login" style="color: var(--text-primary); background-color: var(--color-secondary-button)">Login</button>
        </div>
      </div>
    </div>
    <div></div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import { useLoginStore } from "@/stores/loginStore";
import { useThemeStore } from "@/stores/themeStore";
import CommonAPIService from "@/servicehandlers/CommonHandler";
import MessageModal from "@/components/MessageModal.vue";
import LoadingPage from "@/components/LoadingPage.vue";

const commonService = new CommonAPIService()
export default {
  name: 'LoginPage',
  components: {
    LoadingPage,
    MessageModal,
  },
  data(){
    return {
      loading: false,
      appMessage: {
        text: '',
        type: 'error',
      },
      error: {
        text: '',
        title: '',
      },
      email: '',
      password: '',
      viewPassword: false,
      showDropdown: false,
      store: useLoginStore(),
      themeStore: useThemeStore()
    }
  },
  computed: {
    currentTheme() {
      return this.themeStore?.currentTheme || 'dark';
    }
  },
  mounted() {
    //console.clear()
    if (this.store.loggedIn){
      this.goToHome()
    }
  },
  methods: {
    togglePasswordVisibility(){
      this.viewPassword = !this.viewPassword
    },
    toggleDropdown(){
      this.showDropdown = !this.showDropdown
    },
    login(){
      this.loading = true
      const login = {
        username: this.email,
        password: this.password,
      };
      return commonService
          .login(login, this.$router, this.store, [])
          .then((response) => {
            console.log(response)
            if (response.status === 402) {
              this.appMessage.text = response.message
              this.appMessage.type = 'info'
              this.$refs.messageModal.open()
              this.loading = false
              return
            }
            if (response && response.success) {
              this.store.setPastLogging(true);
              this.goToHome();
            } else {
              this.appMessage.text = 'Incorrect Email or Password. Please try again.'
              this.appMessage.type = 'error'
              this.$refs.messageModal.open()
            }
            this.loading = false
          })
          .catch(e => {
            //console.log(e)
            this.appMessage.text = e
            this.appMessage.type = 'error'
            this.$refs.messageModal.open()
            this.loading = false
          });
    },
    handleEmailEnter(){
      if (this.password){
        this.login()
      } else {
        this.$refs.password.focus();
      }
    },
    async goToHome(){
      this.$router.push({
        name: 'dashboard'
      })
    },
    toggleTheme() {
      // Toggle theme in theme store
      const newTheme = this.themeStore.toggleTheme();
      
      // Save theme preference in login store
      this.store.setSelectedTheme(newTheme);
    },
  },
}
</script>

<style scoped>
.theme-switch-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.theme-switch {
  background: var(--color-card);
  border: 1px solid var(--color-card-border);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-primary);
  font-size: 20px;
}

.theme-switch:hover {
  background: var(--color-background-input);
  transform: scale(1.05);
}

.colorSwap{
  color: #45403C !important;
  background-color: transparent !important;
}
.rightCaret{
  color: white;
  width: 12px;
  height: 21px;
}
.otherWrapper{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
}
.logo {
  display: block;
  margin: 2rem auto;
  width: 100%;
  height: auto;
  margin-top: 7rem;
  transition: filter 0.3s ease;
}

.logo.inverted {
  filter: invert(1);
}
.loginContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  max-width: 500px;
  border-radius: 12px;
  padding: 20px;
}
.emailContainer{
  width: 100%;
}
.emailContainer, .passwordContainer{
  width: 100%;
  position: relative;
}
.viewPasswordIcon{
  position: absolute;
  right: 0;
  top: calc(50% - 10p);
  width: 50px;
  height: 50px;
  color: var(--text-secondary);
  background-color: #45403C;
  padding: 7.5px;
  border-radius: 12px;
}
input{
  font-size: 20px;
  height: 50px;
}
.loginInput::placeholder {
  color: var(--color-border-input);
  font-family: 'Poppins', 'Inter', sans-serif;
}
.dropdownWrapper{
  width: 100%;
  margin: 10px 0;
}
.dropdownToggle{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.dropdownToggle:hover{
  background: var(--color-background-input);
}
.dropdownToggle span{
  color: var(--text-primary);
  font-size: 22px;
  font-family: 'Poppins', 'Inter', sans-serif;
}
.dropdownCaret{
  color: var(--text-primary);
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}
.dropdownCaret.rotated{
  transform: rotate(90deg);
}
.dropdownContent{
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
  margin-top: -2px;
  transition: all 0.3s ease;
}
.dropdownContent.show{
  max-height: 200px;
  border-width: 2px;
  border-top: none;
}
.dropdownItem{
  padding: 10px 15px;
}
.dropdownItem:last-child{
  border-bottom: none;
}
.dropdownButton{
  display: block;
  width: 100%;
  padding: 10px 15px;
  background: var(--color-secondary-button);
  color: var(--text-primary);
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Poppins', 'Inter', sans-serif;
  text-align: center;
  transition: all 0.3s ease;
}
.dropdownButton:hover{
  background: var(--color-secondary-button-border);
  text-decoration: none;
}
.forgotPasswordLink{
  color: var(--color-secondary-button);
  text-decoration: none;
  font-size: 14px;
  display: block;
  text-align: center;
  padding: 10px 15px;
  font-family: 'Poppins', 'Inter', sans-serif;
}
.forgotPasswordLink:hover{
  text-decoration: underline;
}
</style>
